import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom'
import { NavLink, Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import LoadingSpinner from '../loadingspinner/LoadingSpinner';
import FeatureServiceWrapper from "../featureservicewrapper/FeatureServiceWrapper";
import { Context } from "../configcontext/ConfigContext";
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AccountMapping2.css';

class AccountMapping extends React.Component {

	static contextType = Context;

	constructor(props) {
		super(props);
		this.state = {
			jwt: "",
			loading: true,
			authorized: false,
			featureServices: [],
			esriFeatureServices: [],
			userMapping: [],
			modalBody: "",
			modalHeader: "",
			inactive: [],
			show: false,
			mapping: [{ "feature_service_type_id": 8, "feature_layers": [{ "feature_layer_type_id": 29, "feature_name": "territory", "feature_fields": [] }] }, 
			{ "feature_service_type_id": 10, "feature_layers": [{ "feature_layer_type_id": 45, "feature_name": "controlpoint", "feature_fields": [] }] }, { "feature_service_type_id": 1, "feature_layers": [{ "feature_layer_type_id": 1, "feature_name": "watermain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 2, "feature_name": "waterservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 3, "feature_name": "waterhydrant" }, { "feature_layer_type_id": 4, "feature_name": "waterservicevalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 5, "feature_name": "watermainvalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 35, "feature_name": "watermainfitting" }, { "feature_layer_type_id": 36, "feature_name": "waterservicefitting" }] }, { "feature_service_type_id": 2, "feature_layers": [{ "feature_layer_type_id": 6, "feature_name": "electricprimaryoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 7, "feature_name": "electricprimaryunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 8, "feature_name": "electricpole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 9, "feature_name": "electrictransformer" }, { "feature_layer_type_id": 10, "feature_name": "electricmanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 30, "feature_name": "electricsecondaryunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 31, "feature_name": "electricsecondaryoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 32, "feature_name": "electricserviceunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 33, "feature_name": "electricserviceoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 34, "feature_name": "electricpoletransformer" }] }, { "feature_service_type_id": 3, "feature_layers": [{ "feature_layer_type_id": 11, "feature_name": "gasmain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 12, "feature_name": "gasservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 13, "feature_name": "gasmainvalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 14, "feature_name": "gasservicevalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }] }, { "feature_service_type_id": 4, "feature_layers": [{ "feature_layer_type_id": 15, "feature_name": "stormmain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 16, "feature_name": "stormservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 17, "feature_name": "stormcatchbasin", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 18, "feature_name": "stormmanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 5, "feature_layers": [{ "feature_layer_type_id": 19, "feature_name": "fiberprimaryunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 20, "feature_name": "fiberprimaryoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 21, "feature_name": "fibermanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 6, "feature_layers": [{ "feature_layer_type_id": 22, "feature_name": "telecomunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 23, "feature_name": "telecomoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 24, "feature_name": "telecommanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 7, "feature_layers": [{ "feature_layer_type_id": 25, "feature_name": "sanitarymain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 26, "feature_name": "sanitaryservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 27, "feature_name": "sanitarymanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 9, "feature_layers": [{ "feature_layer_type_id": 37, "feature_name": "steammain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 38, "feature_name": "steamanchor", "feature_fields": [{ "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 39, "feature_name": "steamexpansionjoint", "feature_fields": [{ "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 40, "feature_name": "steamfitting", "feature_fields": [{ "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 41, "feature_name": "steamcontrolvalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 43, "feature_name": "steamvault" }, { "feature_layer_type_id": 44, "feature_name": "steamservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }] }],
			mappingNew: []
		}
		this.handleDropdown = this.handleDropdown.bind(this);
		this.changeRadio = this.changeRadio.bind(this);
		this.getUserMapping = this.getUserMapping.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showModal = this.showModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.updateFeatureService = this.updateFeatureService.bind(this);
		this.updateFeatureLayer = this.updateFeatureLayer.bind(this);
		this.updateMappedAttributes = this.updateMappedAttributes.bind(this);
		this.addFeatureLayer = this.addFeatureLayer.bind(this);
		this.updateFeatureField = this.updateFeatureField.bind(this);
		this.updateShapefile = this.updateShapefile.bind(this);
		this.deleteLayer = this.deleteLayer.bind(this);
	}

	componentDidMount() {
		let value = this.context;
		axios.post('https://www.arutility.com/api/v5/esri/esriServices/read.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } })
			.then(res => {
				let featureServices = res.data.services.map(featureService => {
					return { name: featureService.name }
				});
				this.setState({ featureServices: [{ name: '' }].concat(featureServices), esriFeatureServices: [{ name: '' }].concat(res.data.services), loading: false });
			}).catch(error => {
				if (error.response) {
					if (error.response.status == 401) {
						this.setState({ modalBody: "Sorry there was an error: " + error.response.data.message, modalHeader: "Error", show: true, loading: false });
					} else {
						this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
					}
				} else if (error) {
					this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
				} else {
					this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
				}
			});
		axios.post('https://www.arutility.com/api/v5/esri/featureService/readAll.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } }).then(res => {
			var mappingNew = JSON.parse(JSON.stringify(res.data.message));
			//console.log(mappingNew);
			var numServices = mappingNew.length;
			//console.log(numServices);
			for(var i = 0; i < numServices; i++){
				var numLayers = mappingNew[i].feature_layers.length;
				//console.log(numLayers);
				//console.log(mappingNew);
				for(var i2 = 0; i2 < numLayers; i2++){
					var layerCopy = JSON.parse(JSON.stringify(mappingNew[i].feature_layers[i2]));
					//console.log(layerCopy);
					//GENERATE RANDOM ID
					var length = 4;
					var result = '';
				    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				    var charactersLength = characters.length;
				    for ( var i3 = 0; i3 < length; i3++ ) {
				      result += characters.charAt(Math.floor(Math.random() * charactersLength));
				   	}
				   	layerCopy["feature_layer_map_index"] = result;
				   	layerCopy["feature_layer_mapped_id"] = "";
					layerCopy["feature_layer_name"] = "";
					layerCopy["feature_service_name"] = "";
					layerCopy["feature_layer_url"] = "";
					layerCopy["feature_layer_mapped_fields"] = [];
					layerCopy["attributes"] = [];
					layerCopy["shapefile"] = false;
					layerCopy["sorting_index"] = i2;
					mappingNew[i].feature_layers[i2] = layerCopy;
				}
			}
			//console.log(mappingNew);
			this.setState({mappingNew: mappingNew}, this.getUserMapping);
			//NOW ASSIGN A RANDOM ID TO EACH LAYER SO WE CAN UPDATE, DELETE AND ADD NEW LAYERS FROM EACH INDIVIDUAL FEATURE LAYER COMPONENT

			}).catch(error => {
				if (error.response) {
					if (error.response.status == 401) {
						this.setState({ modalBody: "Sorry there was an error: " + error.response.data.message, modalHeader: "Error", show: true, loading: false });
					} else {
						this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
					}
				} else if (error) {
					this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
				} else {
					this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
				}
			});
	}

	getUserMapping() {
		let value = this.context;
		axios.post('https://www.arutility.com/api/v5/esri/featureService/read.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } })
			.then(res => {
				this.setState({userMapping: res.data});
				var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
				//console.log(this.state.mappingNew);
				var numUserMapping = res.data.length;
				for (var i = 0; i < numUserMapping; i++) {
					var featureLayerIdUser = parseInt(res.data[i].feature_layer_type_id);
					var numMapping = this.state.mappingNew.length;
					for (var i2 = 0; i2 < numMapping; i2++) {
						var numLayers = this.state.mappingNew[i2].feature_layers.length;
						var isMatch = false;
						var matchIndex;
						var sortingIndex = 0;
						for (var i3 = 0; i3 < numLayers; i3++) {
							if (this.state.mappingNew[i2].feature_layers[i3].feature_layer_type_id == featureLayerIdUser) {
								//console.log("Feature Layer Type Matches");
								isMatch = true;
								matchIndex = i3;
								if(this.state.mappingNew[i2].feature_layers[i3].sorting_index > sortingIndex){
									sortingIndex = this.state.mappingNew[i2].feature_layers[i3].sorting_index;
									//console.log("Sorting Index = " + sortingIndex);
								}
							}
						}
						if(isMatch){
							//Have to do this to create a deep clone of the array so it doesn't update state
							var featureLayerCopy = JSON.parse(JSON.stringify(this.state.mappingNew[i2].feature_layers[matchIndex]));
							featureLayerCopy["feature_layer_mapped_id"] = res.data[i].feature_layer_id;
							featureLayerCopy["feature_layer_name"] = res.data[i].feature_layer_name;
							featureLayerCopy["feature_service_name"] = res.data[i].feature_service_name;
							featureLayerCopy["feature_layer_url"] = res.data[i].feature_layer_url;
							if(res.data[i].attributes != ""){
								var attributeArray = res.data[i].attributes.split(',');
								featureLayerCopy["attributes"] = attributeArray;
							}else{
								featureLayerCopy["attributes"] = [];
							}
							featureLayerCopy["feature_layer_mapped_fields"] = res.data[i].fields;
							featureLayerCopy["shapefile"] = parseInt(res.data[i].shapefile);
							featureLayerCopy["sorting_index"] = sortingIndex + 1;
							var length = 4;
							var result = '';
						    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
						    var charactersLength = characters.length;
						    for ( var i4 = 0; i4 < length; i4++ ) {
						      result += characters.charAt(Math.floor(Math.random() * charactersLength));
						   	}
						   	featureLayerCopy["feature_layer_map_index"] = result;
							mappingNew[i2].feature_layers.splice(0, 0, featureLayerCopy);
						}	
					}
				}
				//console.log(mappingNew);
				this.setState({mappingNew: mappingNew});
			}).catch(error => {
				//console.log(error);
				if (error.response) {
					if (error.response.status == 401) {
						this.setState({ loading: false });
					} else {
						this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
					}
				} else if (error) {
					this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
				} else {
					this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
				}
			});
	}

	handleDropdown(e) {
		var elementName = e.target.id + "Wrapper";
		let element = document.getElementById(elementName);
		if (this.state[e.target.id] == false) {
			ReactDOM.findDOMNode(element).style.display = "block";
			this.setState({ [e.target.id]: true });
		} else {
			ReactDOM.findDOMNode(element).style.display = "none";
			this.setState({ [e.target.id]: false });
		}
	}

	changeRadio(e) {
		var radioName = e.target.id + "Shapefile";
		if (this.state[radioName] == false) {
			this.setState({ [radioName]: true });
		} else {
			this.setState({ [radioName]: false });
		}
	}

	handleSubmit() {
		this.setState({ loading: true });
		let value = this.context;
		var mapping = [];
		var fullArray;
		var numServices = this.state.mappingNew.length;
		for (var i = 0; i < numServices; i++) {
			var numLayers = this.state.mappingNew[i].feature_layers.length;
			for (var i2 = 0; i2 < numLayers; i2++) {
				if(this.state.mappingNew[i].feature_layers[i2].feature_service_name != ""){
					var fields = [];
					if (this.state.mappingNew[i].feature_layers[i2].feature_layer_mapped_fields) {
						var numFields = this.state.mappingNew[i].feature_layers[i2].feature_layer_mapped_fields.length;
						for (var i3 = 0; i3 < numFields; i3++) {
							var field = {"field_type_id": this.state.mappingNew[i].feature_layers[i2].feature_layer_mapped_fields[i3].field_type_id, "field_name": this.state.mappingNew[i].feature_layers[i2].feature_layer_mapped_fields[i3].alias};
							fields.push(field);
						}
					}
					var featureService = {
						"allow_shapefiles": this.state.mappingNew[i].feature_layers[i2].shapefile,
						"attributes": this.state.mappingNew[i].feature_layers[i2].attributes,
						"feature_layer_id": this.state.mappingNew[i].feature_layers[i2].feature_layer_mapped_id,
						"feature_layer_name": this.state.mappingNew[i].feature_layers[i2].feature_layer_name,
						"feature_layer_type_id": parseInt(this.state.mappingNew[i].feature_layers[i2].feature_layer_type_id),
						"feature_layer_url": this.state.mappingNew[i].feature_layers[i2].feature_layer_url, 
						"feature_service_name": this.state.mappingNew[i].feature_layers[i2].feature_service_name, 
						"feature_service_type_id": this.state.mappingNew[i].feature_service_type_id,					
						"fields": fields					
					};
					mapping.push(featureService);
				}
			}
		}
		var mappingArray = mapping;
		//var inactiveArray = [];
		axios.post('https://www.arutility.com/api/v5/accounts/mapping/update.php', {mapping: mappingArray, inactive: this.state.inactive}, { headers: { Authorization: 'Bearer ' + value.jwt } })
			.then(res => {
				this.setState({ loading: false, modalBody: "Mapping successfully updated", modalHeader: "Success", show: true });
			}).catch(error => {
				if (error.response) {
					this.setState({ loading: false, modalBody: "Sorry, there was an error. " + error.response.data, modalHeader: "Error", show: true });
				} else if (error.request) {
					// The request was made but no response was received
					this.setState({ loading: false, modalBody: "Sorry, there was an error. " + error.request, modalHeader: "Error", show: true });
				} else {
					// Something happened in setting up the request that triggered an Error
					this.setState({ loading: false, modalBody: "Sorry, there was an error. " + error.message, modalHeader: "Error", show: true });
				}
			});
			this.setState({inactive: []});
	}

	showModal() {
		this.setState({ show: true });
	}

	closeModal() {
		this.setState({ show: false });
	}

	updateFeatureService(feature_service_name, feature_layer_map_index){
		//console.log(feature_service_name + " " + feature_layer_map_index);
		var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
		var numServices = mappingNew.length;
		for(var i = 0; i < numServices; i++){
			if(mappingNew[i].feature_layers){
				var numLayers = mappingNew[i].feature_layers.length;
				for(var i2 = 0; i2 < numLayers; i2++){
					if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
						//console.log("Here, feature layer map index matches");
						mappingNew[i].feature_layers[i2].feature_service_name = feature_service_name;
					}
				}
			}
		}
		this.setState({mappingNew: mappingNew});
	}

	updateFeatureLayer(feature_layer_name, feature_layer_map_index, layer_url){
		//console.log(feature_layer_name + " " + feature_layer_map_index);
		var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
		var numServices = mappingNew.length;
		for(var i = 0; i < numServices; i++){
			if(mappingNew[i].feature_layers){
				var numLayers = mappingNew[i].feature_layers.length;
				for(var i2 = 0; i2 < numLayers; i2++){
					if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
						//console.log("Here, feature layer map index matches");
						mappingNew[i].feature_layers[i2].feature_layer_name = feature_layer_name;
						mappingNew[i].feature_layers[i2].feature_layer_url = layer_url;
					}
				}
			}
		}
		this.setState({mappingNew: mappingNew});
	}

	updateMappedAttributes(feature_layer_map_index, mapped_attributes){
		//console.log(feature_layer_name + " " + feature_layer_map_index);
		var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
		var numServices = mappingNew.length;
		for(var i = 0; i < numServices; i++){
			if(mappingNew[i].feature_layers){
				var numLayers = mappingNew[i].feature_layers.length;
				for(var i2 = 0; i2 < numLayers; i2++){
					if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
						//console.log("Here, feature layer map index matches");
						mappingNew[i].feature_layers[i2].attributes = mapped_attributes;
					}
				}
			}
		}
		this.setState({mappingNew: mappingNew});
	}

	addFeatureLayer(feature_layer_map_index){
		//console.log(feature_layer_map_index);
		var mappingNewCopy = JSON.parse(JSON.stringify(this.state.mappingNew));
		//console.log(this.state.mappingNew);
		//console.log(JSON.parse(JSON.stringify(mappingNewCopy)));
		var numMapping = mappingNewCopy.length;
		for (var i2 = 0; i2 < numMapping; i2++) {
			var numLayers = mappingNewCopy[i2].feature_layers.length;
			var isMatch = false;
			var matchIndex;
			var sortingIndex = 0;
			for (var i3 = 0; i3 < numLayers; i3++) {
				if (mappingNewCopy[i2].feature_layers[i3].feature_layer_map_index == feature_layer_map_index) {
					//console.log(JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[i3].feature_layer_map_index)));
					//console.log(i3);
					//console.log(JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers)));
					//console.log(JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[i3])));
					isMatch = true;
					matchIndex = i3;
				}
			}
			if(isMatch){
				for(var i3 = 0; i3 < mappingNewCopy[i2].feature_layers.length; i3++){
					if(mappingNewCopy[i2].feature_layers[i3].sorting_index > sortingIndex){
						sortingIndex = mappingNewCopy[i2].feature_layers[i3].sorting_index;
						//console.log("Sorting Index = " + sortingIndex);
					}
				}
				//Have to do this to create a deep clone of the array so it doesn't update state
				const featureLayerCopy = JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[matchIndex]));
				featureLayerCopy["feature_layer_mapped_id"] = "";
				featureLayerCopy["feature_layer_name"] = "";
				featureLayerCopy["feature_service_name"] = "";
				featureLayerCopy["feature_layer_url"] = "";
				featureLayerCopy["attributes"] = [];
				featureLayerCopy["feature_layer_mapped_fields"] = [];
				featureLayerCopy["shapefile"] = false;
				featureLayerCopy["sorting_index"] = sortingIndex + 1;
				var length = 4;
				var result = '';
			    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			    var charactersLength = characters.length;
			    for ( var i4 = 0; i4 < length; i4++ ) {
			      result += characters.charAt(Math.floor(Math.random() * charactersLength));
			   	}
			   	featureLayerCopy["feature_layer_map_index"] = result;
			   	//console.log(featureLayerCopy);
				mappingNewCopy[i2].feature_layers.push(featureLayerCopy);
			}
		}
		//console.log(JSON.parse(JSON.stringify(mappingNewCopy)));
		this.setState({mappingNew: mappingNewCopy});
	}

	updateFeatureField(feature_layer_map_index, field_type_id, field_alias){
		//console.log(feature_layer_name + " " + feature_layer_map_index);
		var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
		var numServices = mappingNew.length;
		for(var i = 0; i < numServices; i++){
			if(mappingNew[i].feature_layers){
				var numLayers = mappingNew[i].feature_layers.length;
				for(var i2 = 0; i2 < numLayers; i2++){
					if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
						var numFields = mappingNew[i].feature_layers[i2].feature_layer_mapped_fields.length;
						var isMatch = false;
						for(var i3 = 0; i3 < numFields; i3++){
							if(mappingNew[i].feature_layers[i2].feature_layer_mapped_fields[i3].field_type_id == field_type_id){
								mappingNew[i].feature_layers[i2].feature_layer_mapped_fields[i3].alias = field_alias;
								isMatch = true;
							}
						}
						if(isMatch == false){
							mappingNew[i].feature_layers[i2].feature_layer_mapped_fields.push({"alias":field_alias, "field_type_id":field_type_id});
						}
					}
				}
			}
		}
		console.log(mappingNew);
		this.setState({mappingNew: mappingNew});
	}

	updateShapefile(feature_layer_map_index, allowShapefile){
		//console.log(feature_layer_name + " " + feature_layer_map_index);
		var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
		var numServices = mappingNew.length;
		for(var i = 0; i < numServices; i++){
			if(mappingNew[i].feature_layers){
				var numLayers = mappingNew[i].feature_layers.length;
				for(var i2 = 0; i2 < numLayers; i2++){
					if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
						mappingNew[i].feature_layers[i2].shapefile = allowShapefile;
					}
				}
			}
		}
		console.log(mappingNew);
		this.setState({mappingNew: mappingNew});
	}

	deleteLayer(feature_layer_map_index){
		//console.log(feature_layer_map_index);
		var mappingNewCopy = JSON.parse(JSON.stringify(this.state.mappingNew));
		var inactiveArrayCopy = JSON.parse(JSON.stringify(this.state.inactive));
		//console.log(this.state.mappingNew);
		//console.log(JSON.parse(JSON.stringify(mappingNewCopy)));
		var numMapping = mappingNewCopy.length;
		for (var i2 = 0; i2 < numMapping; i2++) {
			var numLayers = mappingNewCopy[i2].feature_layers.length;
			var isMatch = false;
			var matchIndex;
			var numFeatureLayers;
			var feature_layer_type_id;
			var feature_layer_mapped_id;
			for (var i3 = 0; i3 < numLayers; i3++) {
				if (mappingNewCopy[i2].feature_layers[i3].feature_layer_map_index == feature_layer_map_index) {
					isMatch = true;
					matchIndex = i3;
					feature_layer_mapped_id = mappingNewCopy[i2].feature_layers[i3].feature_layer_mapped_id;
					if(feature_layer_mapped_id != ""){
						inactiveArrayCopy.push(feature_layer_mapped_id);
					}
					feature_layer_type_id = mappingNewCopy[i2].feature_layers[i3].feature_layer_type_id;
				}
			}
			if(isMatch){
				console.log("Here");
				var num_feature_layers = 0;
				for(var i3 = 0; i3 < mappingNewCopy[i2].feature_layers.length; i3++){
					if(mappingNewCopy[i2].feature_layers[i3].feature_layer_type_id == feature_layer_type_id){
						num_feature_layers = num_feature_layers + 1;
						console.log("Here");
					}
				}
				if(num_feature_layers > 1){
					mappingNewCopy[i2].feature_layers.splice(matchIndex,1);
					break;
				}else{
					const featureLayerCopy = JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[matchIndex]));
					featureLayerCopy["feature_layer_mapped_id"] = "";
					featureLayerCopy["feature_layer_name"] = "";
					featureLayerCopy["feature_service_name"] = "";
					featureLayerCopy["feature_layer_url"] = "";
					featureLayerCopy["attributes"] = [];
					featureLayerCopy["feature_layer_mapped_fields"] = [];
					featureLayerCopy["shapefile"] = false;
					featureLayerCopy["sorting_index"] = 1;
					var length = 4;
					var result = '';
				    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				    var charactersLength = characters.length;
				    for ( var i4 = 0; i4 < length; i4++ ) {
				      result += characters.charAt(Math.floor(Math.random() * charactersLength));
				   	}
				   	featureLayerCopy["feature_layer_map_index"] = result;
				   	mappingNewCopy[i2].feature_layers.splice(matchIndex,1);
				  	mappingNewCopy[i2].feature_layers.push(featureLayerCopy);
				  	break;
				}
			}
		}
		//console.log(inactiveArrayCopy);
		this.setState({mappingNew: mappingNewCopy, inactive: inactiveArrayCopy});
		//console.log(this.state);
	}

	render() {
		const { loading, authorized, show } = this.state;
		let value = this.context;
		var parent = this;
		if (value.jwt == "") {
			return (
				<Route>
					<Redirect to="/login" />
				</Route>
			);
		} else {
			if (value.userPermissions.includes("mapping:update")) {
				return (
					<div className="mainWrapper">
						<div className="mainWindow">
							{this.state.loading &&
							<LoadingSpinner />
							}
							<Modal show={show} onHide={this.closeModal}>
								<Modal.Header closeButton>
									<Modal.Title>{this.state.modalHeader}</Modal.Title>
								</Modal.Header>
								<Modal.Body>{this.state.modalBody}</Modal.Body>
								<Modal.Footer>
									<Button variant="secondary" onClick={this.closeModal}>
										Close
					              </Button>
								</Modal.Footer>
							</Modal>
							<div className="pageHeader">
								UTILITY MAPPING
					      	</div>
							<div className="plainBody">
								Please map your utilities with the appropriate ARUtility layers below. First select the appropriate feature service that contains the correct layer. Once you've selected a feature service, the available feature layers will be loaded.

								If you do not have any data to map to a specific ARUtility layer, leave the drop down blank and it will be ignored. ARUtility handles field validation. Only fields with data types that match those supported by ARUtilty will be displayed.
								<br />
								<br />
								Diameter field units must be in inches. Height field units must be in feet. Heights and depths are relative to the ground surface. Values may be either negative or positive, ARUtility will handle any necessary conversions for display in augmented reality.
								<br />
								<br />
								Don't see a feature service or feature layer that you'd like to share? Reach out via email at support@arutility.com or via our <a href="https://www.arutility.com/contact">contact us</a> page. We can add new feature services and layers in 1 business day.
								{this.state.mappingNew.sort(function(a, b){if(a.sorting < b.sorting) return -1; if(a.sorting > b.sorting) return 1; if(a.sorting == b.sorting){if(a.name > b.name) return 1; if(a.name < b.name) return -1;}}).map((featureService, index) => 
									(parent.context.userPermissions.includes("mapping:" + featureService.name + ":update") &&
										<FeatureServiceWrapper key={featureService.feature_service_type_id} label={featureService.label} name={featureService.name} feature_service_type_id={featureService.feature_service_type_id} feature_layers={featureService.feature_layers} esri_feature_services={this.state.esriFeatureServices} updateFeatureService={this.updateFeatureService} updateFeatureLayer={this.updateFeatureLayer} updateMappedAttributes={this.updateMappedAttributes} addFeatureLayer={this.addFeatureLayer} updateFeatureField={this.updateFeatureField} updateShapefile={this.updateShapefile} deleteLayer={this.deleteLayer}/>
									))
								}
								<button id="submitMappingSettings" className="submitProjectBtn" onClick={this.handleSubmit} >SAVE CHANGES</button>
							</div>
						</div>
					</div>
				);
			} else {
				return (
					<Route>
						<Redirect to="/projects" />
					</Route>
				);
			}
		}
	}
}

export default AccountMapping;